import { render } from "./tpr.vue?vue&type=template&id=13ee9296"
import script from "./tpr.vue?vue&type=script&lang=js"
export * from "./tpr.vue?vue&type=script&lang=js"

import "./tpr.vue?vue&type=style&index=0&id=13ee9296&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__